import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ReportConfig } from './report-config.model';

const url = environment.api;

@Injectable({
  providedIn: 'root'
})
export class ReportConfigService {

  constructor(private http: HttpClient) { }

  reportConfigs: ReportConfig[];
  reportConfig: ReportConfig;

  getReportConfigurations() {
    return this.http.get(url + 'report-configuration-group');
  }

  getReportConfiguration(reportConfigId: number) {
    return this.http.get(url + 'report-configuration-group/' + reportConfigId);
  }

  updateReportConfiguration(id: number, reportConfig: ReportConfig) {
    return this.http.put(url + 'report-configuration-group/' + id, reportConfig);
  }

  createReportConfiguration(reportConfig: ReportConfig) {
    return this.http.post(url + 'report-configuration-group/', reportConfig);
  }

  deleteReportConfiguration(reportConfigId: number) {
    return this.http.delete(url + 'report-configuration-group/' + reportConfigId);
  }

  createReportConfigurationUser(confId: number, userId: number) {
    return this.http.post(url + 'report-configuration-group/' + confId + '/user/' + userId, null);
  }

  deleteReportConfigurationUser(confId: number, userId: number) {
    return this.http.delete(url + 'report-configuration-group/' + confId + '/user/' + userId);
  }




}
